import { useCreateTandemSource as useCreateTandemSourceAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useSources } from "./useSources"
import { useEventReloading } from "src/contexts/LoadingContexts"
import { noticeError } from "src/utils"

export function useCreateTandemSource() {
  const createTandemSource = useCreateTandemSourceAPI()
  const { mutate } = useSources()
  const { requestReload } = useEventReloading()

  const createSource = useMemo(
    () => !createTandemSource ? undefined : async (params: Parameters<typeof createTandemSource>[0]) => {
      try {
        const response = await createTandemSource(params)

        void mutate()
        requestReload()

        return response
      } catch (e) {
        noticeError(
          e,
          "CreateTandemSource",
        )

        throw e
      }
    },
    [
      requestReload,
      createTandemSource,
      mutate,
    ],
  )

  return createSource
}
